import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status__dot"
}
const _hoisted_2 = {
  key: 1,
  class: "status__close-area"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "status__divider" }, null, -1)

import { PropType } from "vue";
import { TirPmStatusBgEnum, TirPmStatusTextEnum } from "./enums";
import { CrossCompactIcon } from "tir-style-system/icons/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmStatus',
  props: {
  /**
   * С обводкой
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Лейбл
   */
  label: { type: String as PropType<String>, default: "" },
  /**
   * Цвет лейбла
   */
  labelColor: {
    type: String as PropType<TirPmStatusTextEnum>,
    default: TirPmStatusTextEnum.Default,
  },
  /**
   * Включает точку слева
   */
  isDotted: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Включает точку слева
   */
  isClosable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Цвет фона
   */
  bgColor: { type: String as PropType<TirPmStatusBgEnum>, default: TirPmStatusBgEnum.Positive },
},
  emits: ["onClose"],
  setup(__props, { emit }) {

const props = __props;



const close = () => {
  emit("onClose");
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "status",
    style: _normalizeStyle({
      background: props.bgColor,
      color: props.labelColor,
      border: props.isBordered ? `0.063rem solid ${props.labelColor}` : '',
    })
  }, [
    (props.isDotted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(props.label) + " ", 1),
    (__props.isClosable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "status__inner-icon",
            onClick: close
          }, [
            _createVNode(_unref(CrossCompactIcon))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})